// extracted by mini-css-extract-plugin
export var chip = "_ek-0";
export var filterDropdown = "_ek-5";
export var filterItem = "_ek-6";
export var icon = "_ek-1";
export var removeButton = "_ek-3";
export var removeIcon = "_ek-4";
export var separator = "_ek-2";